import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import MainFooter from "../../components/common/mainFooter";
import MainHeader from "../../components/common/mainHeader";
import {
    IsNullOrEmpty
} from "../../helpers/utility";
import ShoppingAPI from "../../store/shopping/shopping.api";
import {
    Avatar, Box, Container, Grid, Typography, Modal, Button, Tooltip, Dialog, DialogContent
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { getImage } from "../../store/user/user.selector";
import ReactImageGallery from "react-image-gallery";
import SignIn from "./login";

function UserGuestInfo() {
    const location = useLocation();
    const [userName, setUserName] = useState("");
    const [userProfile, setUserProfile] = useState({});
    const [isProductLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [products, setProducts] = useState([]);
    const [showPic, setPic] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isCart, setCart] = useState(false);
    const [loginModal, setLoginModal] = useState(false);

    useEffect(() => {
        if (location && location.pathname) {
            let uName = location.pathname.split('/').pop();
            setUserName(uName);
        }
    }, [location]);

    useEffect(() => {
        setLoading(true);
        if (!IsNullOrEmpty(userName)) {
            ShoppingAPI.GetAnonymousProducts(userName).then((x) => {
                setUserProfile(x.data.user);
                setProducts(x.data.products);
            }).finally(() => setLoading(false))
        }
    }, [userName]);

    if (!userProfile._id) {
        return isLoading ? <>
            <MainHeader />
            <div className="formContainer">
                <div className="container">
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        />
                    </Box>
                </div>
            </div>
            <MainFooter />
        </> : <>
            <MainHeader />
            <div className="formContainer">
                <div className="container">
                    <div className="px-2 sm:px-4 lg:px-8 py-7">
                        <div className="flex items-center justify-center w-full h-screen">
                            <div className="px-2 sm:px-4 lg:py-12">
                                <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
                                    <h1 className="font-bold text-purple-color text-8xl sm:text-9xl">
                                        404
                                    </h1>
                                    <p className="mb-2 text-xl sm:text-2xl font-bold text-center text-gray-800 md:text-3xl">
                                        <span className="text-red-500">Oops!</span> Page not
                                        found
                                    </p>
                                    <p className="mb-8 text-center text-gray-500 md:text-lg">
                                        The page you’re looking for doesn’t exist.
                                    </p>
                                    <Link
                                        to="/"
                                        className="px-6 py-2 text-sm font-semibold text-white bg-orange-color rounded-sm capitalize"
                                    >
                                        Go home
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MainFooter />
        </>
    }

    return <>
        <MainHeader />
        <div className="formContainer">
            <div className="container">
                <Grid container maxWidth={false}>
                    <Grid item xs={12} sm={12}>
                        <Container maxWidth="sm">
                            <Box display="flex" textAlign="center" alignItems="center" justifyContent="center" flexDirection="column">
                                <Avatar alt={userProfile.fullName} onClick={() => setPic(true)} style={{ height: 200, width: 200 }} src={getImage(userProfile.avatar.attachments)} />
                                <Typography className="mt-4" variant="span" component="h6">
                                    <span className="text-large">{userProfile.fullName}</span> {userProfile.role === "Pro" && <button className='role-label-o'>Pro</button>}
                                </Typography>
                                <Typography className="my-1" variant="span" component="p">
                                    <span className="text-gray">@{userProfile.userName}</span>
                                </Typography>
                                <Typography className="my-1" variant="span" component="p">
                                    {userProfile.descriptions}
                                </Typography>
                                <Typography className="my-2" variant="span" component="p">
                                    <a className="anchor" target="_blank" rel="noopener noreferrer" href={userProfile.website}>{userProfile.website}</a>
                                </Typography>
                                <Box display="flex" className="my-2" alignItems="center" justifyContent="space-between">
                                    <p><span className="text-large text-bold">{userProfile.countFollower}</span>&nbsp;<span className="text-medium text-grey">Followers</span></p>
                                    <p className="ml-4"><span className="text-large text-bold">{userProfile.countFollowing}</span>&nbsp;<span className="text-medium text-grey">Following</span></p>
                                    <p className="ml-4"><span className="text-large text-bold">{userProfile.countSubscriber}</span>&nbsp;<span className="text-medium text-grey">Subscribers</span></p>
                                </Box>
                            </Box>
                        </Container>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Grid container spacing={1} className="mt-4">
                            {products &&
                                products.map(
                                    (
                                        product
                                    ) => {
                                        return (
                                            <Grid item xs={12} sm={12} lg={4} xl={4}>
                                                <div
                                                    key={
                                                        product._id
                                                    }
                                                    className="mb-5"
                                                >
                                                    <div className="px-3.5 py-2 border border-black-10 rounded-md bg-white">
                                                        <div className="grid grid-cols-2 gap-x-[18px]">
                                                            <div className="">
                                                                <ReactImageGallery
                                                                    showNav={
                                                                        false
                                                                    }
                                                                    showPlayButton={
                                                                        false
                                                                    }
                                                                    items={
                                                                        product
                                                                            .allAttachments
                                                                            .length >
                                                                            0
                                                                            ? product.allAttachments
                                                                                .concat(
                                                                                    product.attachments
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        x
                                                                                    ) => {
                                                                                        return {
                                                                                            thumbnailWidth: 32,
                                                                                            thumbnailHeight: 32,
                                                                                            id: x._id,
                                                                                            original:
                                                                                                getImage(
                                                                                                    x
                                                                                                ),
                                                                                            thumbnail:
                                                                                                getImage(
                                                                                                    x
                                                                                                ),
                                                                                        };
                                                                                    }
                                                                                )
                                                                            : [
                                                                                {
                                                                                    thumbnailWidth: 32,
                                                                                    thumbnailHeight: 32,
                                                                                    id: product
                                                                                        .attachments
                                                                                        ._id,
                                                                                    original:
                                                                                        getImage(
                                                                                            product.attachments
                                                                                        ),
                                                                                    thumbnail:
                                                                                        getImage(
                                                                                            product.attachments
                                                                                        ),
                                                                                },
                                                                            ]
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="">
                                                                <h5 className="text-md text-black-50">
                                                                    {
                                                                        product.name
                                                                    }
                                                                </h5>
                                                                <p className="text-md font-medium text-orange-color uppercase mb-1.5">
                                                                    {
                                                                        product.currency
                                                                    }{" "}
                                                                    {product.price.toFixed(
                                                                        2
                                                                    )}
                                                                </p>

                                                                <p className="text-sm font-medium text-black capitalize mb-[1px]">
                                                                    Stock
                                                                    Quantity:{" "}
                                                                    {
                                                                        product
                                                                            .warehouse
                                                                            .quantity
                                                                    }
                                                                </p>
                                                                <Tooltip
                                                                    title={product.descriptions}
                                                                >
                                                                    <p className="text-md font-normal text-black-50">
                                                                        {
                                                                            product.descriptions.length > 100
                                                                                ? product.descriptions.slice(0, 100) +
                                                                                "..."
                                                                                : product.descriptions
                                                                        }
                                                                    </p>
                                                                </Tooltip>
                                                            </div>
                                                        </div>

                                                        <div className=" flex items-center gap-5 mt-5">
                                                            <button
                                                                onClick={() => {
                                                                    setCart(
                                                                        true
                                                                    );
                                                                    setSelectedProduct(
                                                                        product._id
                                                                    );
                                                                    setLoginModal(
                                                                        true
                                                                    );
                                                                }}
                                                                className="py-[7px] w-full block capitalize rounded-lg text-sm font-medium bg-white border border-black-10 text-black-50 whitespace-nowrap"
                                                            >
                                                                Add
                                                                to
                                                                Cart
                                                            </button>
                                                            <button
                                                                onClick={() => {
                                                                    setCart(
                                                                        false
                                                                    );
                                                                    setSelectedProduct(
                                                                        product._id
                                                                    );
                                                                    setLoginModal(
                                                                        true
                                                                    );
                                                                }}
                                                                className="py-[7px] w-full block capitalize rounded-lg text-sm font-bold bg-orange-color text-white whitespace-nowrap"
                                                            >
                                                                Buy
                                                                it
                                                                Now
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Grid>
                                        );
                                    }
                                )}
                            {
                                products.length === 0 && !isProductLoading &&
                                <Grid item sm={12} xs={12}>
                                    <Container maxWidth="sm">
                                        <Box className="text-center">
                                            <Alert severity="warning">
                                                No products to display
                                            </Alert>
                                        </Box>
                                    </Container>
                                </Grid>
                            }
                        </Grid>

                    </Grid>
                </Grid >
                <Modal
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    open={showPic}
                    onClose={() => setPic(false)}
                >
                    <Avatar style={{ height: 256, width: 256 }} alt={userProfile.fullName} src={getImage(userProfile.avatar.attachments)} onClick={() => setPic(false)} />
                </Modal>
                <Modal
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    open={selectedProduct._id}
                    onClose={() => setSelectedProduct({})}
                >
                    <Avatar style={{ height: 256, width: 256 }} alt={selectedProduct.title}
                        src={getImage(selectedProduct.attachments)} onClick={() => setSelectedProduct({})} />
                </Modal>
            </div>
        </div>
        <Dialog
            maxWidth="sm"
            open={loginModal}
            onClose={() => setLoginModal(false)}
        >
            <DialogContent>
                <SignIn
                    showContent={true}
                    product={selectedProduct}
                    isCart={isCart}
                />
            </DialogContent>
        </Dialog>
        <MainFooter />
    </>
}

export default UserGuestInfo;
